import {
  ACCESS_TOKEN,
  API_BASE_URL_AUTH,
  API_BASE_URL_COMMON,
  API_BASE_URL_WORKFLOW,
  API_BASE_URL_PAYMENT,
  API_BASE_URL_SINVOICE,
  API_BASE_URL_CINVOICE,
  API_BASE_URL_CONTRACT,
  API_URLS,
} from './config.js';
import { request } from './request';



export function sLoadStep(taskid, entity, entityid) {
  const lancode = localStorage.getItem('lancode');

  return request({
    url: `${API_BASE_URL_WORKFLOW}/GetTaskStepEntity?taskid=${taskid}&entity=${entity}&entityid=${entityid}&lancode=${lancode}`,
    method: 'GET',
  });
}

export function sLoadCheck(taskid, entity, entityid) {
  const lancode = localStorage.getItem('lancode');

  return request({
    url: `${API_BASE_URL_WORKFLOW}/GetTaskCheckEntity?taskid=${taskid}&entity=${entity}&entityid=${entityid}&lancode=${lancode}`,
    method: 'GET',
  });
}

export function sExecuteEvent(funcode, taskid, Entity, EntityId) {
  const lancode = localStorage.getItem('lancode');

  return request({
    url: `${API_BASE_URL_WORKFLOW}/${funcode}taskid=${taskid}&Entity=${Entity}&EntityId=${EntityId}&lancode=${lancode}`,
    method: 'POST',
  });
}

export function sLoadConseq(taskid, entity, entityid) {
  const lancode = localStorage.getItem('lancode');

  return request({
    url: `${API_BASE_URL_WORKFLOW}/GetTaskConseqEntity?taskid=${taskid}&entity=${entity}&entityid=${entityid}&lancode=${lancode}`,
    method: 'GET',
  });
}

export function sUpdateProcTaskCheckStatus(proctaskcheckid, checkstatus) {
  return request({
    url: `${API_BASE_URL_WORKFLOW}/UpdateProcTaskCheckStatus?proctaskcheckid=${proctaskcheckid}&checkstatus=${checkstatus}`,
    method: 'GET',
  });
}

export function sSaveProcTaskCheck(
  procid,
  proctaskid,
  proctaskcheckid,
  proccode,
  procmodule,
  entityid,
  taskid,
  checkid,
  checkorder,
  checktype,
  checkcode,
  checkrequesttype,
  receivertype,
  receiverid,
  receiverroleprofile,
  proccodetarget,
  taskidtarget,
  doccode,
  ccode,
  checkstatus
) {
  return request({
    url: `${API_BASE_URL_WORKFLOW}/SaveProcTaskCheck?procid=${procid}&proctaskid=${proctaskid}&proctaskcheckid=${proctaskcheckid}&proccode=${proccode}&procmodule=${procmodule}&entityid=${entityid}&taskid=${taskid}&checkid=${checkid}&checkorder=${checkorder}&checktype=${checktype}&checkcode=${checkcode}&checkrequesttype=${checkrequesttype}&receivertype=${receivertype}&receiverid=${receiverid}&receiverroleprofile=${receiverroleprofile}&proccodetarget=${proccodetarget}&taskidtarget=${taskidtarget}&doccode=${doccode}&ccode=${ccode}&checkstatus=${checkstatus}`,
    method: 'GET',
  });
}

export function loadOfferListByCatalogID(catalogid, prcode) {
  return request({
    url: `${API_BASE_URL_COMMON}/OfferListByCatalogID?catalogid=${catalogid}&prcode=${prcode}`,
    method: 'GET',
  });
}



export function loadParList(parcode) {
  return request({
    url: `${API_BASE_URL_COMMON}/api/parlist/${parcode}`,
    method: 'GET',
  });
}

export function getContractByID(ctrid) {
  return request({
    url: `${API_BASE_URL_CONTRACT}/proposal/${ctrid}`,
    method: 'GET',
  });
}

export function getSupplierInvoicebyID(siid) {
  return request({
    url: `${API_BASE_URL_SINVOICE}/${siid}`,
    method: 'GET',
  });
}

export function getClientInvoicebyID(ciid) {
  return request({
    url: `${API_BASE_URL_CINVOICE}/clientInvoice/${ciid}`,
    method: 'GET',
  });
}
export function getPaymentbyID(payid) {
  return request({
    url: `${API_BASE_URL_PAYMENT}/${payid}`,
    method: 'GET',
  });
}

export async function login(loginRequest) {
  const rawResponse = await fetch(`${API_URLS.AUTHENTICATION_SERVICE}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(loginRequest),
  });
  const content = await rawResponse.json();
  return content;
}


export async function checkLogin() {
  const rawResponse = await fetch(`https://scania.utina.io:9300/authentication-service/usersaml`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  const content = await rawResponse.json();
  return content;
}

export function signup(signupRequest) {
  return request({
    url: `${API_BASE_URL_AUTH}/signup`,
    method: 'POST',
    body: JSON.stringify(signupRequest),
  });
}

export function getCurrentUser() {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject('No access token set.');
  }

  return request({
    url: `${API_URLS.AUTHENTICATION_SERVICE}/me`,
    method: 'GET',
  });
}
